// extracted by mini-css-extract-plugin
export default {"signIn":"signIn_signIn__nymPI"};